import { render, staticRenderFns } from "./cancelPremium.vue?vue&type=template&id=04bd4993&scoped=true&"
import script from "./cancelPremium.vue?vue&type=script&lang=js&"
export * from "./cancelPremium.vue?vue&type=script&lang=js&"
import style0 from "./cancelPremium.vue?vue&type=style&index=0&id=04bd4993&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bd4993",
  null
  
)

export default component.exports